<template><slot></slot></template>

<script setup>
import { getCurrentInstance, onBeforeUnmount, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  emitOnMounted: String,
  emitOnUnmounted: String,
  reactOn: String,
  handler: Function
});

const { proxy } = getCurrentInstance();
if (props.reactOn) {
  proxy.$bus.on(props.reactOn, props.handler);
}
onMounted(() => {
  if (!props.emitOnMounted) return;
  proxy.$bus.emit(props.emitOnMounted);
});
onBeforeUnmount(() => {
  if (!props.reactOn) return;
  proxy.$bus.off(props.reactOn, props.handler);
});
onUnmounted(() => {
  if (!props.emitOnUnmounted) return;
  proxy.$bus.emit(props.emitOnUnmounted);
});
</script>
